import React, { useState } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaSave } from 'react-icons/fa';
import api from '../../services/api';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import SaveButton from '../../components/SaveButton';


export default function AlterarSenha() {
    const token = localStorage.getItem('token');
    const idUsuario = localStorage.getItem('idUsuario');
    const history = useHistory();
    const [dados, setDados] = useState({
        senhaAtual: '',
        novaSenha: '',
        confirmarSenha: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const validar = () => {
        if (!dados.senhaAtual) {
            toast.error('É necessário preencher a senha atual');
            return false;
        }
        if (!dados.novaSenha) {
            toast.error('É necessário preencher a nova senha');
            return false;
        }
        if (dados.novaSenha.length < 6) {
            toast.error('A nova senha deve ter pelo menos 6 caracteres');
            return false;
        }
        if (dados.novaSenha !== dados.confirmarSenha) {
            toast.error('A confirmação da nova senha não confere');
            return false;
        }
        return true;
    };

    const salvar = () => {
        if (!validar()) {
            return false;
        }
        if (isSubmitting) {
            return;
        }

        setIsSubmitting(true);


        api({
            method: 'put',
            action: '/participante/' + idUsuario,
            token: token,
            data: {
                senhaAtual: dados.senhaAtual,
                novaSenha: dados.novaSenha
            },
        })
            .then(function (response) {
                toast.success('Senha alterada com sucesso!');
                history.push("/principal");
            })
            .catch(function (error) {
                if (error.response && error.response.data && error.response.data.message) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error('Erro ao alterar senha. Verifique se a senha atual está correta.');
                }
            })
                .finally(() => {
                    setIsSubmitting(false);
                });
    };

    return (
        <ErpTemplate processando={isLoading}>
            <div className="main-content container-fluid">
                <div className="page-title">
                    <h3>Alterar Senha</h3>
                </div>
                <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-content">
                                    <div className="card-body">
                                        <form className="form" onSubmit={(e) => { salvar(); e.preventDefault(); }}>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="form-floating form-group">
                                                        <input
                                                            type="password"
                                                            className="form-control form-control-lg"
                                                            id="senhaAtual"
                                                            placeholder="Senha Atual"
                                                            value={dados.senhaAtual}
                                                            onChange={e => setDados({ ...dados, ...{ "senhaAtual": e.target.value } })}
                                                        />
                                                        <label htmlFor="senhaAtual">Senha Atual</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="form-floating form-group">
                                                        <input
                                                            type="password"
                                                            className="form-control form-control-lg"
                                                            id="novaSenha"
                                                            placeholder="Nova Senha"
                                                            value={dados.novaSenha}
                                                            onChange={e => setDados({ ...dados, ...{ "novaSenha": e.target.value } })}
                                                        />
                                                        <label htmlFor="novaSenha">Nova Senha</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="form-floating form-group">
                                                        <input
                                                            type="password"
                                                            className="form-control form-control-lg"
                                                            id="confirmarSenha"
                                                            placeholder="Confirmar Nova Senha"
                                                            value={dados.confirmarSenha}
                                                            onChange={e => setDados({ ...dados, ...{ "confirmarSenha": e.target.value } })}
                                                        />
                                                        <label htmlFor="confirmarSenha">Confirmar Nova Senha</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 d-flex justify-content-end">
                                                    <SaveButton isSubmitting={isSubmitting}>Alterar Senha</SaveButton>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </ErpTemplate>
    );
}

